export default () => ({
  reports: [],
});
